/* eslint-disable @typescript-eslint/unbound-method */
import React from 'react';
import {Icon1, Icon2, Icon3, Icon4, Icon5, Icon6, Icon7, Icon8, Icon9, Icon10, Icon11, IconProps} from './Icons/Icons';
import classNames from 'clsx';
import s from './CartIconApp.scss';
import {ICartIconSantaProps, ICtrlProps} from '../../../types/app-types';
import md5 from 'md5';

export type ICartIconAppProps = ICtrlProps & ICartIconSantaProps;

const icons: {[key: string]: React.ComponentType<IconProps>} = {
  Icon1,
  Icon2,
  Icon3,
  Icon4,
  Icon5,
  Icon6,
  Icon7,
  Icon8,
  Icon9,
  Icon10,
  Icon11,
};

export class CartIconApp extends React.Component<ICartIconAppProps, {isAfterHydration: boolean}> {
  private readonly anchorRef: React.RefObject<HTMLAnchorElement>;
  constructor(props) {
    super(props);
    this.anchorRef = React.createRef();

    this.onClick = this.onClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onHover = this.onHover.bind(this);
    this.reportAppLoaded = this.reportAppLoaded.bind(this);
    this.state = {
      isAfterHydration: false,
    };
  }

  public componentDidMount(): void {
    this.props.host.registerToComponentDidLayout(this.reportAppLoaded);
    /* istanbul ignore else: todo: missing test */
    if (!this.state.isAfterHydration) {
      this.setState({isAfterHydration: true});
    }
  }

  public componentDidUpdate(prevProps: ICartIconAppProps): void {
    /* istanbul ignore next: todo: missing test */
    if (this.props.triggerFocus !== prevProps.triggerFocus) {
      this.triggerFocus();
    }
    /* istanbul ignore next: todo: missing test */
    if (!this.state.isAfterHydration) {
      this.setState({isAfterHydration: true});
    }
  }

  private reportAppLoaded() {
    /* istanbul ignore else: todo: missing test */
    if (this.props.isInteractive) {
      this.safeRun(this.props.onAppLoaded);
    }
  }

  private renderIcon(iconId: number, count: number | undefined, text: string) {
    const IconComponent = icons[`Icon${iconId}`];
    const {
      viewMode,
      dimensions: {width, height},
    } = this.props.host;
    const aspectRatio = viewMode === 'Site' || this.props.fixCartIconOnEditor ? width / height : undefined;

    return (
      <IconComponent
        iconId={iconId}
        count={count}
        text={text}
        s={s}
        aspectRatio={aspectRatio}
        containerHeight={this.props.host.dimensions.height}
        containerWidth={this.props.host.dimensions.width}
        fixCartCountOverlap={this.props.fixCartCountOverlap}
      />
    );
  }

  private onClick(event) {
    event.preventDefault();
    if (!this.props.isNavigate) {
      event.stopPropagation();
    }
    this.safeRun(this.props.onIconClick);
  }

  private onKeyDown(event: React.KeyboardEvent<HTMLAnchorElement>) {
    if (!this.props.ecomFixCartIconSpacebarActivation || this.props.isNavigate) {
      return;
    }
    if (event.key === ' ') {
      this.onClick(event);
    }
  }

  private onHover(event) {
    event.preventDefault();
    this.safeRun(this.props.onIconHover);
  }

  /* istanbul ignore next: todo: missing test */
  private triggerFocus() {
    this.anchorRef.current && this.anchorRef.current.focus();
    this.safeRun(this.props.onFocusTriggered);
  }

  private safeRun(fn) {
    /* istanbul ignore else: todo: missing test */
    if (this.props.isInteractive && typeof fn === 'function') {
      fn();
    }
  }

  private componentKey() {
    const {
      host: {
        style: {
          styleParams: {fonts},
        },
      },
    } = this.props;
    return `cart-icon-${md5(JSON.stringify(fonts))}`;
  }

  public isStudioSite(isAfterHydration: boolean): boolean {
    if (!isAfterHydration) {
      return false;
    }
    const editorBrand = (window as any)?.commonConfig?.brand;
    return editorBrand === 'studio';
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  public render(): React.ReactNode {
    /* istanbul ignore next: todo: missing test */
    if (!this.props.isLoaded) {
      return null;
    }

    const {cartLink, displayText, isNavigate} = this.props;
    const {isAfterHydration} = this.state;
    const count = isAfterHydration ? this.props.count : undefined;
    const ariaLabelLink = isAfterHydration ? this.props.ariaLabelLink : undefined;
    const {style} = this.props.host;
    const iconId: number = (style && style.styleParams.numbers.cartWidgetIcon) || 1;

    const classes = classNames(
      s[`cart-icon-${iconId}`],
      s.cartIconButtonContainer,
      count
        ? {
            [s.dozens]: count >= 10 && count <= 99,
            [s.hundreds]: count >= 100,
          }
        : {}
    );

    const {host, count: itemsCount} = this.props;
    const {height} = host.dimensions;

    const hasValidHeight = !!height;
    const hasValidCount = itemsCount !== undefined || !this.isStudioSite(isAfterHydration);

    const iconsThatSupportSSR = [1, 2, 6, 8, 9, 10, 11];

    const shouldRender =
      iconsThatSupportSSR.includes(iconId) || ((isAfterHydration || hasValidHeight) && hasValidCount);

    return shouldRender ? (
      <a
        key={this.componentKey()}
        aria-label={ariaLabelLink}
        className={classes}
        data-hook={'cart-icon-button'}
        href={isAfterHydration ? cartLink : undefined}
        onClick={this.onClick}
        onKeyDown={this.onKeyDown}
        onMouseEnter={this.onHover}
        ref={this.anchorRef}
        role={isNavigate ? 'link' : 'button'}>
        {this.renderIcon(iconId, count, displayText)}
      </a>
    ) : null;
  }
}
